import axios from 'axios';
import store from "./../store/index";
import router from './../router'

const API_BASEURL = process.env.VUE_APP_API_DOMAIN;
axios.defaults.baseURL = API_BASEURL;

// APIのheaderには認証情報をつける
axios.interceptors.request.use((config) => {
  config.headers["X-Auth-Token"] = store.state.auth.xAuthToken;
  return config;
});

// ステータスコード次第でそれぞれのエラー画面に遷移
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // APIで認証切れの場合はログインページに遷移
    if (error.response.status === 401) {
      router.push({
        path: '/login',
        query: {
          sessionTimeout: true
        }
      });
    } else if (error.response.status === 403) {
      router.push({ path: '/error/403' });
    } else if (error.response.status === 500) {
      router.push({ path: '/error/500' });
    }
    return Promise.reject(error);
  }
);

export default axios;
